import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { FicheIntervention } from 'app/models/ficheIntervention.model';
import { FicheInterventionService } from 'app/services/fiche-intervention.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Router } from '@angular/router';
import { DebrisTypeEquipement } from 'app/models/debrisTypeEquipement.model';
import { DebrisTypeEquipementService } from 'app/services/debris-type-equipement.service';
import { MatDialog } from '@angular/material/dialog';
import {
    ModalFormDebrisTypeEquipementComponent
} from '../../fiche-intervention/edit-fiche-intervention/form-fiche-intervention/modal-form-debris-type-equipement/modal-form-debris-type-equipement.component';

@Component({
  selector: 'app-fiche-intervention-v2',
  templateUrl: './fiche-intervention-v2.component.html'
})
export class FicheInterventionV2Component implements OnInit {
  @Input() currentFicheIntervention: FicheIntervention = new FicheIntervention();
  @Input() idDossierIntervention: number;
  @Output() valueChanged = new EventEmitter();
  success: boolean = false;
  error: boolean = false;
  tabIndex: number = 0;

  debrisTypesEquipements: DebrisTypeEquipement[];

  ficheInterventionForm: FormGroup;
  constructor(private ficheInterventionService: FicheInterventionService, private debrisTypeEquipementService: DebrisTypeEquipementService, public dialog: MatDialog,  private router: Router) { }

  ngOnInit(): void {
    this.initForm();
    this.getDebrisTypesEquipements();

    this.ficheInterventionForm.valueChanges.subscribe(() => {
      this.valueChanged.emit(true);
    });
  }

  initForm() {
    this.ficheInterventionForm = new FormGroup({
      dossier_intervention_id: new FormControl(this.idDossierIntervention),
      date_contact: new FormControl(this.currentFicheIntervention.date_contact, [Validators.required]),
      date_intervention: new FormControl(this.currentFicheIntervention.date_intervention),
      categorie_intervention: new FormControl(this.currentFicheIntervention.categorie_intervention),
      contenu_rapporte_urgex: new FormControl(this.currentFicheIntervention.contenu_rapporte_urgex),
      travaux_a_effectuer: new FormControl(this.currentFicheIntervention.travaux_a_effectuer),
      cause_sinistre: new FormControl(this.currentFicheIntervention.cause_sinistre),
      recommendation: new FormControl(this.currentFicheIntervention.recommendation),
      camion_usine: new FormControl(this.currentFicheIntervention.camion_usine != null ? this.currentFicheIntervention.camion_usine.slice(0, 5) : null, [Validators.pattern('^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$')]),
      debris_type_equipement_id: new FormControl(this.currentFicheIntervention.debris_type_equipement_id != null ? Number(this.currentFicheIntervention.debris_type_equipement_id) : null),
      debris_quantite: new FormControl(this.currentFicheIntervention.debris_quantite),
      sacs_ordure: new FormControl(this.currentFicheIntervention.sacs_ordure),
    });
  }

  getDebrisTypesEquipements(): void{
    this.debrisTypeEquipementService.getDebrisTypesEquipements().subscribe((debrisTypesEquipements) => {
      this.debrisTypesEquipements = debrisTypesEquipements;
    });
  }

  onFormSubmit(): void {
    this.error = false;
    this.success = false;
    this.ficheInterventionForm.markAllAsTouched();

    if (this.ficheInterventionForm.valid) {
      const ficheIntervention = new FicheIntervention(this.ficheInterventionForm.value);
      if (this.currentFicheIntervention.id !== 0) {
        this.ficheInterventionService.update(ficheIntervention, this.currentFicheIntervention.id).subscribe(
          (response) => {
            this.success = true;
            this.valueChanged.emit(false);
          }, (error) => { this.error = true; }
        );
      } else {
        this.ficheInterventionService.store(ficheIntervention).subscribe(
          (response) => {
            this.success = true;
            this.valueChanged.emit(false);
          }, (error) => { this.error = true; }
        );
      }
    }
  }

  ajouterDebrisTypeEquipement(): void{
    event.stopPropagation();
    const dialogRef = this.dialog.open(ModalFormDebrisTypeEquipementComponent, {
      width: '35%',
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result != undefined) {
        this.getDebrisTypesEquipements();
        this.ficheInterventionForm.patchValue({
          debris_type_equipement_id: result.id != null ? +result.id : null
        });
      }
    });
  }

  changeCamionUsine(): void {
      const value = this.ficheInterventionForm.value.camion_usine.replace(/[^0-9]/g, '');
      if (value.length > 2) {
          this.ficheInterventionForm.patchValue({
              camion_usine: value.slice(0, 2) + ':' + value.slice(2)
          });
      }
  }
}
